module.exports = __webpack_public_path__ + "img/nutrition_6.7e6489b2.jpg";